module.exports = __webpack_public_path__ + "grundwasser.55f51356dcf104749a96946b42797384.png";